import React from 'react'
import { isEmpty } from 'ramda'

const Loading = () => <div>Loading...</div>
const load = (data, cnt) => (isEmpty(data) ? <Loading /> : cnt)
export default load
